// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_LookupByQrcodeResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/orders/lookup_by_qrcode/{qrcode}.
 *
 * Returns the matched item plus its work-order steps (empty list when no
 * work order exists yet).
 */
import type { Orders_LookupQrcodeItemRow } from './Orders_LookupQrcodeItemRow'
import type { Orders_WorkOrderStepRow } from './Orders_WorkOrderStepRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_LookupByQrcodeResponseDados {
item: Orders_LookupQrcodeItemRow
steps: Orders_WorkOrderStepRow[]
}

export type Orders_LookupByQrcodeResponse = ApiResponse<Orders_LookupByQrcodeResponseDados>;

registerResponseContract('Orders_LookupByQrcodeResponse', {
  item: {
    type: 'object',
    required: true,
    fields: {
      so_order_item_id:                          { type: 'number',  required: true },
      so_order_item_order_id:                    { type: 'number',  required: true },
      so_order_item_type:                        { type: 'string',  required: true },
      so_order_item_parent_item_id:              { type: 'number',  required: false },
      so_order_item_service_id:                  { type: 'number',  required: false },
      so_order_item_additional_service_id:       { type: 'number',  required: false },
      so_order_item_additional_service_price_id: { type: 'number',  required: false },
      so_order_item_priority_id:                 { type: 'number',  required: false },
      so_order_item_product_id:                  { type: 'number',  required: false },
      so_order_item_quantity:                    { type: 'number',  required: true },
      so_order_item_unit_price:                  { type: 'number',  required: true },
      so_order_item_description:                 { type: 'string',  required: false },
      so_order_item_discount_type:               { type: 'string',  required: false },
      so_order_item_discount_value:              { type: 'number',  required: false },
      so_order_item_total:                       { type: 'number',  required: true },
      so_order_item_deadline_days:               { type: 'number',  required: false },
      so_order_item_qrcode:                      { type: 'string',  required: false },
      so_order_item_alerts:                      { type: 'string',  required: false },
      so_order_item_notes:                       { type: 'string',  required: false },
      so_order_item_service_label:               { type: 'string',  required: false },
      so_order_item_franchise_id:                { type: 'number',  required: false },
      so_order_item_delivered_at:                { type: 'string',  required: false },
      so_order_item_expected_delivery_at:        { type: 'string',  required: false },
      so_order_item_created_at:                  { type: 'string',  required: true },
      so_order_id:                               { type: 'number',  required: true },
      so_order_status:                           { type: 'string',  required: true },
      so_order_client_id:                        { type: 'number',  required: false },
      so_order_created_at:                       { type: 'string',  required: true },
      so_order_client_name:                      { type: 'string',  required: false },
      so_work_order_id:                          { type: 'number',  required: false },
      so_work_order_status:                      { type: 'string',  required: false },
      so_work_order_deadline_at:                 { type: 'string',  required: false },
      so_work_order_started_at:                  { type: 'string',  required: false },
      so_work_order_completed_at:                { type: 'string',  required: false },
    },
  },
  steps: {
    type: 'array',
    required: true,
    items: {
      so_work_order_step_id:                 { type: 'number',  required: true },
      so_work_order_step_work_order_id:      { type: 'number',  required: true },
      so_work_order_step_production_step_id: { type: 'number',  required: true },
      so_work_order_step_name:               { type: 'string',  required: true },
      so_work_order_step_order:              { type: 'number',  required: true },
      so_work_order_step_status:             { type: 'string',  required: true },
      so_work_order_step_started_at:         { type: 'string',  required: false },
      so_work_order_step_completed_at:       { type: 'string',  required: false },
      so_work_order_step_assignee_user_id:   { type: 'string',  required: false },
      so_work_order_step_notes:              { type: 'string',  required: false },
      so_work_order_step_source:             { type: 'string',  required: true },
      so_work_order_step_order_item_id:      { type: 'number',  required: false },
      so_work_order_step_created_at:         { type: 'string',  required: true },
      so_work_order_step_was_resumed:        { type: 'number',  required: false },
    },
  },
})
